// extracted by mini-css-extract-plugin
export default {"wrapper":"DownloadMaterials_wrapper__m4vvo"};